import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { AppConstant } from 'src/app/app.constant';
import { map, tap } from 'rxjs/operators';
import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';
import { AdditionDeductionSet, Payslip } from './payroll.classes';
@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  apiUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl();
  }
  manageAdditionDeductionSet(additionDeductionSet) {
    return this.httpClient.post(`${this.apiUrl}/manageAdditionDeductionSet`, additionDeductionSet).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllAdditionDeductionSet() {
    return this.httpClient.get(`${this.apiUrl}/getAllAdditionDeductionSet/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  getAllAdditionDeductionSetByUserRole(userRole: number) {
    return this.httpClient.get(`${this.apiUrl}/getAllAdditionDeductionSetByUserRole/` + userRole).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }

  manageAdditionDeduction(additionDeductionData) {
    return this.httpClient.post(`${this.apiUrl}/manageAdditionDeduction`, additionDeductionData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllAdditionDeductionBySet(additionDeductionSetId: number) {
    return this.httpClient.get(`${this.apiUrl}/getAllAdditionDeductionBySet/` + additionDeductionSetId).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }
  deleteAdditionDeduction(Id: number) {
    return this.httpClient.delete(`${this.apiUrl}/deleteAdditionDeduction/` + Id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  generatePayslip(paySlipData: Payslip) {
    return this.httpClient.post(`${this.apiUrl}/generatePayslip`, paySlipData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllPayslips(state: DataSourceRequestState): Observable<DataResult> {
    let params = {
      state: state,
    }
    return this.httpClient.post(`${this.apiUrl}/getAllPayslip/`, params).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  getAllPayslipsExcel(state: DataSourceRequestState) {
    let params = {
      state: state,
    }
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/getAllPayslip/`, params).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
}
